import { render, staticRenderFns } from "./UserCompanyAccess.vue?vue&type=template&id=7910222c&scoped=true&"
import script from "./UserCompanyAccess.vue?vue&type=script&lang=js&"
export * from "./UserCompanyAccess.vue?vue&type=script&lang=js&"
import style0 from "./UserCompanyAccess.vue?vue&type=style&index=0&id=7910222c&scoped=true&lang=css&"
import style1 from "./UserCompanyAccess.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7910222c",
  null
  
)

export default component.exports